<template>
  <div>
    <!-- LISTAGEM PRINCIPAL -->
    <v-row dense v-if="documents.length">
      <v-col v-for="doc in documents" :key="doc.id" cols="12" sm="6" md="4">
        <v-card outlined>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="subtitle-2">
                {{ documentLabel(doc.type) }}
              </v-list-item-title>

              <v-list-item-subtitle class="text-caption">
                {{ doc.fileName }}
              </v-list-item-subtitle>
            </v-list-item-content>

            <!-- AÇÕES -->
            <v-list-item-action>
              <v-btn icon @click="edit(doc)">
                <v-icon :color="insurer.color">mdi-pencil</v-icon>
              </v-btn>
            </v-list-item-action>

            <v-list-item-action>
              <v-btn icon @click="remove(doc.id)">
                <v-icon :color="insurer.color">mdi-delete</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>

    <!-- ADICIONAR -->
    <v-btn
      outlined
      block
      :color="insurer.color"
      class="mt-3"
      @click="openDialog()"
    >
      <v-icon left>mdi-plus</v-icon>
      Adicionar documentos
    </v-btn>

    <!-- DIALOG -->
    <v-dialog v-model="dialog" max-width="420" persistent>
      <v-card>
        <v-card-title>
          {{ editingId ? "Alterar documento" : "Adicionar documento" }}
          <v-spacer />
          <v-btn icon @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-select
            v-model="form.type"
            :items="documentTypes"
            item-text="text"
            item-value="value"
            label="Tipo de documento"
            outlined
            dense
            :color="insurer.color"
          />

          <!-- DOCUMENTO ATUAL (EDIÇÃO) -->
          <v-alert v-if="editingFileName" dense text type="info" class="mt-3">
            Documento atual:
            <strong>{{ editingFileName }}</strong>
          </v-alert>

          <v-file-input
            v-model="form.file"
            label="Selecionar ficheiro"
            outlined
            dense
            :color="insurer.color"
            prepend-icon=""
            prepend-inner-icon="mdi-paperclip"
            class="mt-3"
          />
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <!-- BOTÃO SEMPRE VISÍVEL -->
          <v-btn
            :color="insurer.color"
            block
            class="mt-3"
            :disabled="isSaveDisabled"
            :dark="!isSaveDisabled"
            @click="save"
          >
            {{ editingId ? "Atualizar" : "Adicionar" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
const STORAGE_KEY = "dna_documents";

export default {
  name: "RiskLocationDocumentsStep",

  props: {
    insurer: Object,
  },

  data() {
    return {
      dialog: false,

      documents: [],

      editingId: null,
      editingFileName: null,

      form: {
        type: null,
        file: null,
      },

      documentTypes: [
        { value: "property_booklet", text: "Caderneta predial" },
        { value: "invoice", text: "Faturas" },
        { value: "budget", text: "Orçamentos" },
        { value: "report", text: "Relatórios técnicos" },
        { value: "iban", text: "Comprovativo bancário (IBAN)" },
      ],
    };
  },

  methods: {
    openDialog() {
      this.resetForm();
      this.dialog = true;
    },

    closeDialog() {
      this.resetForm();
      this.dialog = false;
    },

    edit(doc) {
      this.editingId = doc.id;
      this.editingFileName = doc.fileName;
      this.form.type = doc.type;
      this.form.file = null;
      this.dialog = true;
    },

    save() {
      if (this.editingId) {
        const index = this.documents.findIndex((d) => d.id === this.editingId);

        this.documents.splice(index, 1, {
          id: this.editingId,
          type: this.form.type,
          fileName: this.form.file ? this.form.file.name : this.editingFileName,
          file: this.form.file || null,
        });
      } else {
        this.documents.push({
          id: crypto.randomUUID(),
          type: this.form.type,
          fileName: this.form.file.name,
          file: this.form.file,
        });
      }

      this.persist();
      this.closeDialog();
    },

    remove(id) {
      this.documents = this.documents.filter((d) => d.id !== id);
      this.persist();
    },

    persist() {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(this.documents));
      this.$emit("update", this.documents);
    },

    load() {
      const raw = localStorage.getItem(STORAGE_KEY);
      this.documents = raw ? JSON.parse(raw) : [];
    },

    resetForm() {
      this.form = { type: null, file: null };
      this.editingId = null;
      this.editingFileName = null;
    },

    documentLabel(type) {
      return (
        {
          property_booklet: "Caderneta predial",
          invoice: "Faturas",
          budget: "Orçamentos",
          report: "Relatórios técnicos",
          iban: "Comprovativo bancário (IBAN)",
        }[type] || "Documento"
      );
    },
  },

  created() {
    this.load();
  },

  computed: {
    isSaveDisabled() {
      if (!this.form.type) return true;

      if (!this.editingId && !this.form.file) return true;

      return false;
    },
  },
};
</script>
